export default __webpack_public_path__ + "static/media/learose-1440w.e0011bf3.avif";